import { useEffect, useMemo, useRef } from "react";
import { useCases } from "./cases";
import { useLang } from "../i18n";
import { enrichProject, projectTranslations } from "../data/project-updates";

// API-backed built-in cases also need the checked-in production gallery assets.
const covers = {"baki-evleri":"/case-covers/baki-evleri.webp","art-tower":"/case-covers/art-tower.webp","25-plaza":"/case-covers/25-plaza.webp","zenith-plaza":"/case-covers/zenith-plaza.webp","fexri-tower":"/case-covers/fexri-tower.webp"};
export const projectForView = (c) => {
 const enriched = enrichProject(c);
 const cover = covers[c.slug];
 if(!cover) return enriched;
 const galleries = {
   "fexri-tower":[1,2,3,4,5].map(i=>`/case-editorial/fexri-approved-0${i}.webp`),
   "art-tower":[1,2,3,4].map(i=>`/case-editorial/art-tower-${i}.webp`),
   "25-plaza":[1,2,3,4].map(i=>`/case-editorial/25-plaza-${i}.webp`),
   "zenith-plaza":[1,2,3,4].map(i=>`/case-editorial/zenith-plaza-${i}.webp`)
 };
 return { ...enriched, cover,
   gallery: c.slug === 'baki-evleri' ? [] : (galleries[c.slug] || enriched.gallery || []),
   videos: c.slug === 'zenith-plaza' ? [
     {url:'/case-editorial/zenith-video-1.mp4',thumbnail:'/case-editorial/zenith-poster-1.jpg'},
     {url:'/case-editorial/zenith-video-2.mp4',thumbnail:'/case-editorial/zenith-poster-2.jpg'}
   ] : enriched.videos
 };
};
export function useProjectCases() {
  const cases = useCases();
  return useMemo(() => cases.map(projectForView), [cases]);
}
export function useProjectReveal(key) {
  const rootRef = useRef(null);
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;
    const items = [...root.querySelectorAll("[data-project-reveal]")];
    if (!items.length) return undefined;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) {
      items.forEach((item) => item.classList.add("is-visible"));
      return undefined;
    }
    root.classList.add("project-reveal-ready");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -32px 0px" });
    items.forEach((item) => observer.observe(item));
    return () => {
      observer.disconnect();
      root.classList.remove("project-reveal-ready");
    };
  }, [key]);
  return rootRef;
}
export function useProjectLang() {
  const context = useLang();
  return { ...context, t: (text) => {
    const translated = context.t(text);
    return context.lang === "az" && translated === text
      ? projectTranslations[text] || translated
      : translated;
  }};
}
